import {ComponentProps} from "react";

import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {useLeadFormCloseTracking} from "../../hooks/use_lead_form_close_tracking";
import {LeadFormAskForFullOffer} from "../lead_form/LeadFormAskForFullOffer";
import {LeadFormModalWrapper} from "./LeadFormModalWrapper";

type IProps = Omit<ComponentProps<typeof LeadFormAskForFullOffer>, "customHeader">;

export const LeadFormModalAskForFullOffer = (props: IProps) => {
    const {handleModalClose} = props;
    const handleModalCloseWithTracking = useLeadFormCloseTracking(handleModalClose);

    return (
        <LeadFormModalWrapper
            handleModalClose={handleModalCloseWithTracking}
            title="Zapytaj dewelopera o pełną ofertę"
            testId={OFFER_TEST_IDS.LEAD_FORM.ASK_FOR_FULL_OFFER_FORM}
        >
            <LeadFormAskForFullOffer {...props} handleModalClose={handleModalCloseWithTracking} customHeader={null} isTwoColumnGrid />
        </LeadFormModalWrapper>
    );
};
